import FullCalendar from '@fullcalendar/react'
import interactionPlugin from '@fullcalendar/interaction'
import dayGridPlugin from '@fullcalendar/daygrid'
import { Card } from 'layouts'
import { renderEventContent } from 'utils'
import { message, Select } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useState, useCallback, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import { LocationSlice, getLocationListDataAction, NavSlice, getALocationDataAction } from 'redux/reducers'
import './DayFullCalendar.scss'
import { getDatePeriodListApi, getListCalendarStatusApi } from 'api'
import { DatePicker } from 'antd'
import moment from 'moment'
// 其他插件...
export const DayFullCalendar = props => {
    const { t } = useTranslation()
    const { authLocationList, typeString, typeSlice, typeApi, eventList, typeRoute } = props

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const fullCalendarRef = useRef()
    const [startDay, setStartDay] = useState() // 日历视图-开始日期
    const [endDay, setEndDay] = useState() // 日历视图-结束日期
    const [currentStart, setCurrentStart] = useState() // 日历视图-当月-开始日期
    const [dailyState, setDailyState] = useState() // 录入状态
    const [datePeriodList, setDatePeriodList] = useState() // 船离队时间
    const userInfo = useSelector(state => state.HeaderSlice.userInfo)
    const projectId = userInfo?.user?.projectId

    const selectedKeys = useSelector(state => state.NavSlice.selectedKeys)

    const locationData = useSelector(state => state.LocationSlice.locationData)
    const locationType = useSelector(state => state.LocationSlice.locationType)

    let congruentLocation
    if (locationType === '') {
        congruentLocation = false
    } else if (locationData?.length !== 1 || locationType !== 'outdoor') {
        congruentLocation = true
    }

    // 其它
    const locationId = useSelector(state => state.LocationSlice.locationId)
    const callSign = useSelector(state => state.LocationSlice.callSign)
    const locationName = useSelector(state => state.LocationSlice.locationName)

    //回显
    const calendarData = useSelector(state => state[typeString].calendarData)

    const calendarInfo = useSelector(state => state[typeString].calendarInfo)
    /* 初始化日历组件钩子, el 为原生事件对象，view 为【日历视图基本信息】 */
    const viewDidMount = ({ el, view }) => {
        if (!userInfo) return
        setStartDay(dayjs(view.activeStart).format('YYYY-MM-DD'))
        setEndDay(dayjs(view.activeEnd).format('YYYY-MM-DD'))
        setCurrentStart(dayjs(view.currentStart).format('YYYY-MM-DD'))
    }
    /* 切换日期 */
    const handleDatePicker = (date, dateString) => {
        const calendarApi = fullCalendarRef.current.getApi() // 获取 api 汇总对象
        calendarApi.gotoDate(dateString) // 调用原生 api，切换日历月份
    }
    /* 操作视图函数： 加载日历，前进后退等，注意它会在组件渲染完成之前就执行 */
    const handleActionView = dateInfo => {
        if (!userInfo) return
        setStartDay(dayjs(dateInfo.view.activeStart).format('YYYY-MM-DD'))
        setEndDay(dayjs(dateInfo.view.activeEnd).format('YYYY-MM-DD'))
        setCurrentStart(dayjs(dateInfo.view.currentStart).format('YYYY-MM-DD'))
        dispatch(typeSlice.actions.addCalendarInfo(dayjs(dateInfo.view.currentStart).format('YYYY-MM-DD'))) // 切换月份，本地存储日历信息
    }
    //////////////////////////日历事件效果/////////////////////////
    /* 创建日历上的事件数据对象 */
    const getEventTitle = [
        ...(calendarData?.map(item => ({
            start: item.produceDate,
        })) || []),
    ]
    //////////////////////////日历事件效果end/////////////////////////
    // ：强制转换为中国时区
    function fixChinaTimezone(dateInput) {
        if (!dateInput) return ''

        // 使用浏览器原生时区转换API
        const chinaDateStr = new Date(dateInput).toLocaleString('en-US', {
            timeZone: 'Asia/Shanghai',
        })

        const chinaDate = new Date(chinaDateStr)
        const year = chinaDate.getFullYear()
        const month = String(chinaDate.getMonth() + 1).padStart(2, '0')
        const day = String(chinaDate.getDate()).padStart(2, '0')

        return `${year}-${month}-${day}`
    }
    // 找到最大的endDate
    const findMaxEndDate = dateList => {
        if (!dateList || dateList?.length === 0) return null

        let maxDate = new Date(dateList?.[0]?.endDate)

        dateList?.forEach(item => {
            const currentDate = new Date(item?.endDate)
            if (currentDate > maxDate) {
                maxDate = currentDate
            }
        })

        return moment(maxDate)?.format('YYYY-MM-DD')
    }
    const selectEvent = async info => {
        if (congruentLocation) {
            if (!locationId) {
                message.warning(t('common.tips10'))
                return
            }
        }
        if (info.startStr) {
            if (
                datePeriodList?.length > 0 &&
                locationType !== 'outdoor' &&
                new Date(findMaxEndDate(datePeriodList)) < new Date(info.startStr)
            ) {
                message.warning(t('common.tips33'))
            }
            dispatch(typeSlice.actions.addCalendarInfo(info.startStr)) // 点击单元格，本地存储点击的日历信息
        } else {
            if (
                datePeriodList?.length > 0 &&
                locationType !== 'outdoor' &&
                new Date(findMaxEndDate(datePeriodList)) <
                    new Date(fixChinaTimezone(info?.event?._instance?.range?.start))
            ) {
                message.warning(t('common.tips33'))
            }
            dispatch(typeSlice.actions.addCalendarInfo(fixChinaTimezone(info?.event?._instance?.range?.start))) // 点击事件，本地存储点击的日历信息
        }
        navigate(selectedKeys[0] + '/detail', { state: { authLocationList, typeRoute } })
    }
    /* 请求日历上的数据 */
    const getCalendarData = useCallback(
        (startDay, endDay, id = locationId) => {
            const calendarParams = {
                dateType: 'day',
                startDay, // 日历开始日期
                endDay, // 日历结束日期
                locationId: id, // 船 ID
                projectId: userInfo?.user?.projectId, // 项目 ID
            }

            dispatch(typeApi(calendarParams)) // 请求日历上的数据
        },
        [locationId, userInfo]
    )
    /* 初始化 - 获取 location 数据 */
    useEffect(() => {
        if (!userInfo) return
        dispatch(getLocationListDataAction(userInfo.user.projectId))
    }, [userInfo])
    /* 初始化 - 获取日历数据 */
    useEffect(() => {
        const isTrue =
            typeRoute === 'project_summary'
                ? !userInfo || !startDay || !endDay
                : !userInfo || !startDay || !endDay || !locationId
        if (isTrue) return
        getCalendarData(startDay, endDay) // 初始化日历上的数据
        const isProjectSummary = typeRoute === 'project_summary'
        const params = isProjectSummary
            ? { projectId, locationId: projectId, menuCode: typeRoute, startDay, endDay }
            : { projectId, locationId, menuCode: typeRoute, startDay, endDay }
        getListCalendarStatusApi(params).then(res => {
            const dailyState = res?.data?.data
            setDailyState(dailyState)
        }) // 初始化日历上的状态
        // 获取每条船的离队时间
        getDatePeriodListApi({
            projectId: projectId,
            locationId: locationId,
        }).then(res => {
            setDatePeriodList(res?.data?.data)
        })
    }, [startDay, endDay, userInfo, locationId])
    /* 默认 location */
    useEffect(() => {
        if (locationData?.length === 0) return
        const result = locationData?.find(p => p?.id === locationId)
        const isCallSign = locationData?.find(p => p?.callSign === callSign)
        if ((!result || !isCallSign) && locationData) {
            dispatch(LocationSlice.actions.addLocationId(locationData[0]?.id))
            dispatch(LocationSlice.actions.addLocationName(locationData[0]?.name))
            dispatch(LocationSlice.actions.addlocationType(locationData[0]?.locationType)) // 设置 location Type
            dispatch(LocationSlice.actions.addlocationCallSign(locationData[0]?.callSign)) // 设置 location callSign
        }
    }, [locationData])

    useEffect(() => {
        if (!typeRoute) return
        dispatch(getALocationDataAction(typeRoute)) // 场所信息
    }, [typeRoute])

    if (!userInfo) return <></>

    return (
        <Card>
            <DatePicker
                onChange={handleDatePicker}
                value={moment(currentStart)}
                picker='month'
                className='datePickerBtn'
                allowClear={false}
                disabledDate={currentDate => {
                    const current = currentDate.format('YYYY-MM-DD')
                    return current < userInfo?.project?.startDate || current > userInfo?.project?.endDate
                }}
            />
            {congruentLocation && (
                <div className='customBtn'>
                    {locationData?.length > 0 || !locationData ? (
                        <Select
                            onChange={(value, locationData) => {
                                dispatch(LocationSlice.actions.addLocationId(locationData?.id)) // 设置 location id
                                dispatch(LocationSlice.actions.addLocationName(locationData?.name)) // 设置 location 名称
                                dispatch(LocationSlice.actions.addlocationType(locationData?.type)) // 设置 location Type
                                dispatch(LocationSlice.actions.addlocationCallSign(locationData?.callSign))
                                getCalendarData(startDay, endDay, locationData?.id) // 获取日历上的数据
                            }}
                            value={locationId ? { label: locationName, value: locationId } : t('common.calendar.tips1')}
                            className={`locationBtn`}
                            options={locationData?.map(item => ({
                                label: item?.name,
                                value: item?.id,
                                id: item?.id,
                                name: item?.name,
                                type: item?.locationType,
                                callSign: item?.callSign,
                            }))}
                        />
                    ) : (
                        <div
                            className={`locationBtn creatLocationBtn`}
                            onClick={() => {
                                const path = '/setting/resources/locations'
                                dispatch(NavSlice.actions.addSelectedKeys([path])) // 记住 menu 选中状态
                                navigate(path)
                            }}
                        >
                            {t('common.calendar.tips2')}
                        </div>
                    )}
                </div>
            )}
            <FullCalendar
                contentHeight='auto' // 日历整体高度由内容决定
                plugins={[dayGridPlugin, interactionPlugin]} // 模块插件加载
                initialView='dayGridMonth' // 初始化视图
                initialDate={calendarInfo ?? currentStart} // 初始化日期
                validRange={nowDate => {
                    if (userInfo) {
                        if (typeRoute === 'acquisition_obn') {
                            return {
                                start: userInfo?.project?.acquisitionStartDate,
                                end: dayjs(userInfo?.project?.acquisitionEndDate).add(1, 'day').format('YYYY-MM-DD'),
                            }
                        }
                        if (typeRoute === 'acquisition_vibrator') {
                            return {
                                start: userInfo?.project?.acquisitionStartDate,
                                end: dayjs(userInfo?.project?.acquisitionEndDate).add(1, 'day').format('YYYY-MM-DD'),
                            }
                        }
                        if (typeRoute === 'activity_diary') {
                            return {
                                start: userInfo?.project?.activityDiaryStartDate,
                                end: dayjs(userInfo?.project?.activityDiaryEndDate).add(1, 'day').format('YYYY-MM-DD'),
                            }
                        }
                        if (typeRoute === 'line_clearance') {
                            return {
                                start: userInfo?.project?.lineClearanceStartDate,
                                end: dayjs(userInfo?.project?.lineClearanceEndDate).add(1, 'day').format('YYYY-MM-DD'),
                            }
                        }
                        if (typeRoute === 'mine_clearance') {
                            return {
                                start: userInfo?.project?.mineClearanceStartDate,
                                end: dayjs(userInfo?.project?.mineClearanceEndDate).add(1, 'day').format('YYYY-MM-DD'),
                            }
                        }
                        if (typeRoute === 'measurement') {
                            return {
                                start: userInfo?.project?.measureStartDate,
                                end: dayjs(userInfo?.project?.measureEndDate).add(1, 'day').format('YYYY-MM-DD'),
                            }
                        }
                        if (typeRoute === 'drill') {
                            return {
                                start: userInfo?.project?.drillStartDate,
                                end: dayjs(userInfo?.project?.drillEndDate).add(1, 'day').format('YYYY-MM-DD'),
                            }
                        }
                        if (typeRoute === 'loading') {
                            return {
                                start: userInfo?.project?.loadingStartDate,
                                end: dayjs(userInfo?.project?.loadingEndDate).add(1, 'day').format('YYYY-MM-DD'),
                            }
                        }
                        if (typeRoute === 'near_surface_inspection') {
                            return {
                                start: userInfo?.project?.nearSurfaceInspectionStartDate,
                                end: dayjs(userInfo?.project?.nearSurfaceInspectionEndDate)
                                    .add(1, 'day')
                                    .format('YYYY-MM-DD'),
                            }
                        }
                        if (typeRoute === 'permit') {
                            return {
                                start: userInfo?.project?.permitStartDate,
                                end: dayjs(userInfo?.project?.permitEndDate).add(1, 'day').format('YYYY-MM-DD'),
                            }
                        }
                        if (typeRoute === 'receiver') {
                            return {
                                start: userInfo?.project?.receiverStartDate,
                                end: dayjs(userInfo?.project?.receiverEndDate).add(1, 'day').format('YYYY-MM-DD'),
                            }
                        } else {
                            return {
                                start: userInfo?.project?.firstReportDate,
                                end: dayjs(userInfo?.project?.lastReportDate).add(1, 'day').format('YYYY-MM-DD'),
                            }
                        }
                    } else {
                        return {}
                    }
                }} // 限制日期可显示范围在：项目开始和结束范围内
                viewDidMount={viewDidMount} // 日历挂载 DOM 钩子
                weekNumbers={false} // 显示周数
                dayCellDidMount={handleActionView} // 切换日期触发钩子
                selectable // 允许点击日历
                selectMirror // 拖动占位符
                select={selectEvent} // 点击日历单元格
                eventClick={selectEvent} // 点击日历事件
                ref={fullCalendarRef} // 实例对象
                events={getEventTitle}
                eventContent={argObj => renderEventContent(argObj, calendarData, eventList, dailyState)} // 自定义日历上的数据
                windowResizeDelay={200} // 防止在用户拖动和调整其浏览器窗口时过于频繁地调整大小，发生 bug：https://github.com/fullcalendar/fullcalendar/issues/5935
                buttonText={{
                    today: t('common.calendar.today'),
                }} // 按钮文本
                headerToolbar={{
                    start: 'prev,next',
                    center: '',
                    end: 'today',
                }}
            />
        </Card>
    )
}
